const isSecure = typeof window !== 'undefined' &&
                 window.location.protocol === 'https:';

export function setCookie(
  key: string,
  value: string,
  expireDays: number,
  path = '/',
  secure: boolean = isSecure
): void {
  if(typeof document === 'undefined') {
    return;
  }

  const date: Date = new Date();
  
  date.setTime(date.getTime() + (expireDays * 24 * 60 * 60 * 1000));

  const exp: string = date.toUTCString();

  let cookieStr = `${ key }=${ value }`;

  if(exp) {
    cookieStr += `; expires=${ exp }`;
  }

  if(path) {
    cookieStr += `; path=${ path }`;
  }

  if(secure) {
    cookieStr += '; secure';
  }

  document.cookie = cookieStr;
}

export function getCookie(key: string): string|undefined {
  if(typeof document === 'undefined') {
    return undefined;
  }

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);

  if(2 === parts.length) {
    return parts.pop()!.split(';').shift();
  }

  return undefined;
}